import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import { userNameReducer } from "../hooks/useUserName";
import { userIdReducer } from "../hooks/useUserId";
import { configSlice } from "./slice/config";
import knowledgerApi from "./api/rtkQueryCodeGen/knowledgerApi/knowledgerApi";
import customerSettingsApi from "./api/rtkQueryCodeGen/customer_settingsApi/customer_settingsApi";
import gosApi from "./api/rtkQueryCodeGen/gosApi/gosApi";
import accessApi from "./api/rtkQueryCodeGen/accessApi/accessApi";
import insightsApi from "./api/rtkQueryCodeGen/insightsApi/insightsApi";
import { signalRLiveReducer } from "src/realtime-signalr";

const rootReducer = combineReducers({
	config: configSlice.reducer,
	userName: userNameReducer,
	userId: userIdReducer,
	signalRLive: signalRLiveReducer,
	[customerSettingsApi.reducerPath]: customerSettingsApi.reducer,
	[knowledgerApi.reducerPath]: knowledgerApi.reducer,
	[gosApi.reducerPath]: gosApi.reducer,
	[accessApi.reducerPath]: accessApi.reducer,
	[insightsApi.reducerPath]: insightsApi.reducer,
});

const store = configureStore({
	reducer: rootReducer,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: false,
		}).concat([knowledgerApi.middleware, gosApi.middleware, accessApi.middleware, customerSettingsApi.middleware, insightsApi.middleware]),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
